import Types from '../../types'
import GlassShape from './../glassShape'
import GlassSegment from '@/model/glassSegment'
import MathsUtils from '@/utils/mathsUtils'


/*
 * RectangleShape
 * Simplest glass shape with a width/height
 */
export default class RectangleShape extends GlassShape {
  constructor(editor, offsetPosition = null, itemData = {}) {
    super(editor, itemData)
    this.objectClassName = 'RectangleShape'
    
    this.shapeType = Types.LibraryItemShapeTypes.rectangle
    this.defaultWidth = MathsUtils.roundNumber(parseFloat(itemData.width || 1000), 1)
    this.defaultHeight = MathsUtils.roundNumber(parseFloat(itemData.height || 1000), 1)

    this.width = this.defaultWidth
    this.height = this.defaultHeight
    this.segmentListEditable = true

    this.reBuildShape(offsetPosition)
  }


  /**
   * Rebuilds the shape segments based on the basic width/height of the rectangle
   * Only to be used when first creating the shape
   */
  reBuildShape(offsetPosition) {
    var startX = offsetPosition ? offsetPosition.x : 0.0
    var startY = offsetPosition ? offsetPosition.y : 0.0

    this.segmentList = []

    let topSegment = new GlassSegment(Types.SegmentTypes.line)
    topSegment.startPosition.set(startX, startY)
    topSegment.endPosition.set(startX + this.width, startY)

    let rightSegment = new GlassSegment(Types.SegmentTypes.line)
    rightSegment.startPosition.set(startX + this.width, startY)
    rightSegment.endPosition.set(startX + this.width, startY + this.height)

    let bottomSegment = new GlassSegment(Types.SegmentTypes.line)
    bottomSegment.startPosition.set(startX + this.width, startY + this.height)
    bottomSegment.endPosition.set(startX, startY + this.height)

    let leftSegment = new GlassSegment(Types.SegmentTypes.line)
    leftSegment.startPosition.set(startX, startY + this.height)
    leftSegment.endPosition.set(startX, startY)

    this.segmentList.push(topSegment)
    this.segmentList.push(rightSegment)
    this.segmentList.push(bottomSegment)
    this.segmentList.push(leftSegment)
  }


  /**
   * Resize the shape
   * Handled by the actual shape classes to rebuild the shape
   */
  resizeShape(width, height) {
    let bounds = this.calculateSegmentBounds()
    if(bounds.isEmpty())
      return

    this.width = width
    this.height = height

    this.reBuildShape(bounds.min)    
  }

  // Clone the rectangle shape
  clone() {
    let newShape = new RectangleShape(this.editor, null, this.itemData)

    newShape.copy(this)
    return newShape
  }

  // Copy the rectangle shape to this shape
  copy(otherShape) {
    super.copy(otherShape)
    
    this.defaultWidth = otherShape.defaultWidth
    this.defaultHeight = otherShape.defaultHeight
    this.width = otherShape.width
    this.height = otherShape.height
  }

  // Serialize/Deserialize to/from a JSON object
  serialize() {
    var outputData = super.serialize()

    outputData.defaultWidth = this.defaultWidth
    outputData.defaultHeight = this.defaultHeight
    outputData.width = this.width
    outputData.height = this.height

    return outputData
  }
  deserialize(object) {
    super.deserialize(object)

    this.defaultWidth = parseFloat(object.defaultWidth || 0)
    this.defaultHeight = parseFloat(object.defaultHeight || 0)
    this.width = parseFloat(object.width || 0)
    this.height = parseFloat(object.height || 0)    
  }
}
